import script from "./WebsitePrice.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsitePrice.vue?vue&type=script&setup=true&lang=js"

import "./WebsitePrice.vue?vue&type=style&index=0&id=fd01f566&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd01f566"]])

export default __exports__